import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { CardComponent } from '../../../core/panels/card.component';
import { IndexSystemReportComponent } from './index-system-report.component';
import { IndexSystemSummaryComponent } from './index-system-summary.component';

@Component({
  selector: 'app-index-system-page',
  imports: [
    PageHeaderComponent,
    IndexSystemSummaryComponent,
    IndexSystemReportComponent,
    CardComponent,
  ],
  template: `
    <app-page-header label="Index System" />
    @if (historyAuth) {
      <div class="tw-flex tw-gap-4 tw-pb-4">
        <app-card label="Index Summary" class="tw-grow">
          <app-index-system-summary></app-index-system-summary>
        </app-card>
      </div>
    }
    @if (reportsAuth) {
      <div class="tw-flex tw-gap-4 tw-pb-4">
        <app-card label="Index Report" class="tw-grow">
          <app-index-system-report></app-index-system-report>
        </app-card>
      </div>
    }
  `,
  styles: [],
})
export class IndexSystemPageComponent extends BaseComponent implements OnInit {
  historyAuth = false;
  reportsAuth = false;

  ngOnInit(): void {
    this.historyAuth = this.session.authorize('IndexSystemHistory');
    this.reportsAuth = this.session.authorize('IndexSystemReports');
    this.view.hideLoading();
  }
}
